import React from 'react';
import LocalizedTextField from '@components/textfield/localized_textfield';
import { I18NText } from '@core/api/ChallengeClient';

interface StyledLocalizedTextFieldProps {
    label: string;
    value: I18NText;
    onChange: (value: I18NText) => void;
    required?: boolean;
}

export const StyledLocalizedTextField: React.FC<
    StyledLocalizedTextFieldProps
> = ({ label, value, onChange, required }) => (
    <div className="w-[250px]">
        <LocalizedTextField
            type="text"
            label={label}
            value={value}
            onChange={onChange}
            size="small"
            required={required}
        />
    </div>
);
